import * as React from "react";
import { withStyles } from "@swiggy-private/core-ui";
import styles from "./styles.scss";
import { LoadingScreen } from "@payment-ui/widgets/loading-screen";

export const FullPageLoader = withStyles(function FullPageLoader(): React.ReactElement {
    return <LoadingScreen className={styles.loading} />;
}, styles);
